import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas);
library.add(fab);
library.add(far);

export function FontIconComponent(props) {
	return (
		<FontAwesomeIcon 
			icon={props.icon}
			className={props.className}
		/>
	)
}